'use strict';/* global define */define('modules/off-canvas/services/off-canvas/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$document", "$timeout"];
function factory($document,$timeout){// jshint validthis:true
// jshint latedef:false
var open=false;return{close:closeIt,isOpen:isOpen,toggle:toggle};// ---
/**
     * Is OffCanvas open at the moment
     *
     * @return {Boolean} - is open
     */function isOpen(){return open;}/**
     * Close the OffCanvas by removing
     * OffCanvas classes
     *
     * Note : This happens after a timeout if open
     * to provide a smooth transition on state changes
     *
     * @type {Function|undefined} callback - callback
     *
     * @tested
     */function closeIt(callback){if(open){// delay to wait for ui-view=body transition
$timeout(function(){$document[0].documentElement.classList.remove('move-left');$document[0].documentElement.classList.remove('move-right');// delay to wait for closing OffCanvas transition
if(typeof callback==='function'){$timeout(callback,500);}$timeout(function(){open=false;},300);},350);}else{if(typeof callback==='function'){callback();}}}/**
     * Toggle the OffCanvas by adding a class
     * to root element
     *
     * @param  {String|undefined} direction - toggle direction
     *
     * @tested
     */function toggle(direction){direction=direction||'right';var elementClass='move-'+direction;$document[0].documentElement.classList.toggle(elementClass);open=!open;}}module.exports=factory;});
